import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import API from '@/api/api';

export function useUserProjectsData(user, isAuthenticated) {
  const [loading, setLoading] = useState(true);
  const [participationEstimates, setParticipationEstimates] = useState([]);
  const [clientProjects, setClientProjects] = useState([]);

  const fetchData = useCallback(async (signal) => {
    if (!isAuthenticated || !user?.company_id) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const companyId = user.company_id;
      const estimatesPromise = API.get(`companies/${companyId}/estimates`, { signal });
      const projectsPromise = API.get(`/clients/${companyId}/projects`, { signal });

      const [estimatesRes, projectsRes] = await Promise.all([estimatesPromise, projectsPromise]);

      setParticipationEstimates(estimatesRes.data || []);
      setClientProjects(projectsRes.data || []);
    } catch (error) {
      if (error.name !== 'CanceledError') {
        message.error('프로젝트 목록 조회에 실패했습니다.');
      }
    } finally {
      setLoading(false);
    }
  }, [user, isAuthenticated]);

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);

    return () => {
      controller.abort();
    };
  }, [fetchData]);

  return { loading, participationEstimates, clientProjects };
}
